<div class="header">
  <h1 mat-dialog-title>{{ data.title | translate:data.params }}</h1>
</div>
<div mat-dialog-content>
  <p class="dialog-message">{{ data.message | translate:data.params }}</p>
</div>

<ng-container>
  {{data.content}}
</ng-container>


<div mat-dialog-actions>
  <button type="button" class="btn btn-cancel" (click)="cancel()">{{ data.cancelText | translate }}</button>
  <button type="button" class="btn btn-confirm" (click)="confirm()">{{ data.confirmText | translate }}</button>
</div>
